'use client'

import React from 'react'

import ZCategoryNavigation from '@/_components/universal/z-category-navigation'
import { ITeamCategory } from '@/_types'
import { SECTION_THEME_ENUM } from '@/_types/base'

interface CategoryItem {
	id?: string | number
	slug: string
	name: string
	sectionTheme?: string | null
}

interface IProps {
	teamCategory: ITeamCategory
	teamCategories: ITeamCategory[]
}

const ATeamCategoryNavigation: React.FC<IProps> = ({ teamCategories, teamCategory }) => {
	const sectionClassMap = {
		[SECTION_THEME_ENUM.WHITE]: 'white',
		[SECTION_THEME_ENUM.SAND]: 'sand',
		[SECTION_THEME_ENUM.TIRQUOISE]: 'tirquoise',
		[SECTION_THEME_ENUM.BLUE]: 'blue',
		[SECTION_THEME_ENUM.PURPLE]: 'purple',
		[SECTION_THEME_ENUM.FUCHSIA]: 'fuchsia',
		[SECTION_THEME_ENUM.CYCLAMEN]: 'cyclamen',
		[SECTION_THEME_ENUM.CYCLAMEN_LIGHT]: 'cyclamen-light',
		[SECTION_THEME_ENUM.PURPLE_LIGHT]: 'purple-light',
		[SECTION_THEME_ENUM.DOCTORS]: 'docs',
		[SECTION_THEME_ENUM.NURSES]: 'sisters',
		[SECTION_THEME_ENUM.MANAGEMENT]: 'management'
	}

	const getLinkClassName = (category: CategoryItem) => {
		const baseClasses =
			'px-6 py-3 font-light rounded-full text-sm transition-colors border !cursor-pointer'
		const isActive = teamCategory.slug === category.slug ? 'active' : ''
		const themeClass =
			sectionClassMap[category.sectionTheme as keyof typeof sectionClassMap] || ''

		return `${baseClasses} ${isActive} ${themeClass}`.trim()
	}

	return (
		<ZCategoryNavigation
			categories={teamCategories.map(cat => ({ ...cat, name: cat.namePlural }))}
			activeCategory={teamCategory?.slug}
			useHash={true}
			className='box_complex-health_nav pos_rel anim_delay anim_drop1 observe dflex justify-between align-center gap-y-2 zindex5 !border-none'
			getLinkClassName={getLinkClassName}
		/>
	)
}

export default ATeamCategoryNavigation
